<section
  class="deie-panel"
  [attr.aria-label]="date() ? 'État DEIE au ' + date() : 'État DEIE'"
  [title]="date() ? 'DEIE au ' + date() : 'DEIE'"
>
  <ul class="deie-items">
    @for (item of items(); track item.libelle) {
      <li class="deie-item" [title]="item.libelle + ' : ' + (item.actif ? 'actif' : 'inactif')">
        <span
          class="deie-dot"
          [class.deie-dot-green]="item.actif"
          [class.deie-dot-red]="!item.actif"
          role="img"
          [attr.aria-label]="item.actif ? 'Actif' : 'Inactif'"
        ></span>
        <span>{{ item.libelle }}</span>
      </li>
    }
  </ul>
</section>
